module.exports = __webpack_public_path__ + "img/item.388755cf.png";